(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxPrinterConnection(
    $http, toastr, $filter, RegexModel
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        enums: '=enums',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/printerProperties/printerSettings/printerConnection/printerConnection.template.html',
      link: function(scope) {

        const regex = new RegexModel();
        const printer = scope.context.printer;
        let protocolList = [];
        let protocolPortMap = {
          IPPS: 443,
          IPP: 80,
          LPR: 515,
          RAW: 9100
        };

        

        function PortProtocolConstructor (portProtocol) {
          this.protocol = portProtocol.protocol;
          this.port = portProtocol.port;
          this.queueName = portProtocol.queueName ? portProtocol.queueName : '';
          this._embedded = portProtocol._embedded;
          this._links = portProtocol._links; 
          this.resetToDefault = false;
          this.portIsValid = false;
          this.pathIsValid = false;
          this.queueNameIsValid = false;
          this.portIsPristine = true;
          this.override = false;
          this.isValid = false;
          this.ippSupportedPath = portProtocol.ippSupportedPath;
          this.choosenPathOption = null;

          this.setPathOption = () => {
            switch (this.ippSupportedPath) {
              case '/':
                this.choosenPathOption = 'ROOT'
              break;
              case '/ipp/print':
                this.choosenPathOption = 'IPP_PRINT'
              break;
              default:
                this.choosenPathOption = 'ENTER_PATH'
              break;
            }
          }

          this.setPathOption();

          this.changeProtocol = (protocol) => {
            this.protocol = protocol.info.name;
            this.port = protocolPortMap[this.protocol];
            this.ippSupportedPath = null;
            this.queueName = '';
            if (this.protocol.indexOf('IPP') > -1) {
              this.ippSupportedPath = '/ipp/print';
              this.setPathOption();
            }
            this.isValid = this.validatePortProtocol();
            return this;
          }

          this.validatePortProtocol = function () {
            switch(this.protocol){
              case 'IPP':
              case 'IPPS':
                return this.validatePortRange() && this.validateIppPath();
              break;
              case 'LPR':
                return this.validatePortRange() && this.queueName.length > 0;
              break;
              case 'RAW':
                return this.validatePortRange();
              break;
            }
          }

          this.validatePortRange = function () {
            if (regex.portRegex().test(this.port)) {
              this.portIsValid = true;
              return true
            } 
            this.portIsValid = false;
            return false
          }

          this.validateIppPath = function () {
            if (regex.pathRegex().test(this.ippSupportedPath) || (this.ippSupportedPath && this.ippSupportedPath.length === 0)) {
              this.pathIsValid = true;
              return true
            } 
            this.pathIsValid = false;
            return false
          }

          this.validateQueueName = function () {

          }

          this.testForOverride = function (ipAddress) {
            if (ipAddress.indexOf('$$') > 0 || ipAddress.indexOf('\\\\') > 0) {
              this.override = true;
            }
          } 
        };


        function ProtocolListConstructor (protocolEnums) {
          this.protocolList = [];

          this.createProtocolList = function (protocolEnums) {
            const protocolTotalList = protocolEnums.map((protocol) => {
              return {
                info: {
                  name: protocol.name,
                  id: protocol.id
                }
              }
            });
  
            this.protocolList = protocolTotalList.filter((protocol) => {
              if (printer.info.ippSupport === 'IPPS') {
                return protocol;
              } else if (printer.info.ippSupport === 'IPP' && protocol.info.name.indexOf('IPPS') < 0) {
                return protocol
              } else if (printer.info.ippSupport === 'NONE' && protocol.info.name.indexOf('IPP') < 0) {
                return protocol;
              }
            })

            return this.protocolList;
          }

          return this.createProtocolList(protocolEnums)
        }

        (function() {
          scope.portProtocol = new PortProtocolConstructor(printer.info._embedded.portProtocol);
          scope.portProtocol.isValid = scope.portProtocol.validatePortProtocol();
          scope.portProtocol.testForOverride(printer.info.ipAddress);
          protocolList = new ProtocolListConstructor(scope.enums.PrintProtocol);
        })();

        scope.selectProtocolList = function () {
          scope.protocolList = protocolList;
        }

        scope.selectProtocol = function (protocol) {
          if (protocol) {
            scope.portProtocol.changeProtocol(protocol);
          } 
          scope.protocolList = null;          
        }

        scope.validatePort = function () {
          scope.portProtocol.isValid = scope.portProtocol.validatePortProtocol();
        }
        
        scope.validatePath = function () {
          scope.portProtocol.isValid = scope.portProtocol.validatePortProtocol();
        }

        scope.validateQueuename = function () {
          scope.portProtocol.isValid = scope.portProtocol.validatePortProtocol();
        }

        scope.save = function () {
          if (!scope.portProtocol.resetToDefault) {
            savePortProtocol()
          } else {
            resetToDefaultPortProtocol();
          }
        }
        
        scope.defaultSetting = function () {
          if (scope.portProtocol.resetToDefault) {
            scope.portProtocol.protocol = 'RAW';
            scope.portProtocol.port = '9100';
            scope.portProtocol.queueName = null;
          } else {
            scope.portProtocol = new PortProtocolConstructor(printer.info._embedded.portProtocol);
            scope.portProtocol.validatePortRange();
            scope.portProtocol.validateIppPath();
            scope.portProtocol.testForOverride(printer.info.ipAddress);
          }
        }

        scope.changePath = function (pathOption) {
          switch (pathOption) {
            case 'ROOT':
              scope.portProtocol.ippSupportedPath = '/';
            break;
            case 'IPP_PRINT':
              scope.portProtocol.ippSupportedPath = '/ipp/print';
            break;
            case 'ENTER_PATH':
              scope.portProtocol.ippSupportedPath = null;
            break;
          }
        }

        function savePortProtocol () {
          printer.savePortProtocol(scope.portProtocol).then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function(error) {
            toastr.error($filter('translate')('ERROR'));
          });
          scope.callback();
        }

        function resetToDefaultPortProtocol () {
          printer.resetToDefaultPortProtocol().then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function(error) {
            toastr.error($filter('translate')('ERROR'));
          });
          scope.callback();
        }


      }
    };
  }

  pxPrinterConnection.$inject = ['$http', 'toastr', '$filter', 'RegexModel'];

  angular
    .module('printix-admin')
    .directive('pxPrinterConnection', pxPrinterConnection);

})();
